import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import { WinProbabilityWrapper, WinProbabilityBoldWrapper, PercentageWrapper } from './WinProbability.style';

const { abs } = Math;

const WinProbability = ({
    awayTeamName,
    homeTeamName,
    halfInning,
    keymoments = {},
    decimalSpot = 1
}) => {
    let teamWinProbability = null;
    let teamWinProbabilityAdded = null;
    let teamName = null;

    const translatedPreText = useTranslator('team_chance_of_winning', 'win probability');
    switch (halfInning) {
    case 'top':
        ({
            awayTeamWinProbabilityAdded: teamWinProbabilityAdded,
            awayTeamWinProbability: teamWinProbability
        } = keymoments);
        teamName = awayTeamName;
        break;
    case 'bottom':
        ({
            homeTeamWinProbabilityAdded: teamWinProbabilityAdded,
            homeTeamWinProbability: teamWinProbability
        } = keymoments);
        teamName = homeTeamName;
        break;
    }
    const plusMinus = teamWinProbabilityAdded >= 0 ? 'plus' : 'minus';
    const validTeamWinProbability = (typeof teamWinProbability !== 'undefined' && teamWinProbability !== null);

    return (validTeamWinProbability &&
        <WinProbabilityWrapper>
            <WinProbabilityBoldWrapper>{ teamName }</WinProbabilityBoldWrapper>
            <span>{ translatedPreText }:</span>
            <WinProbabilityBoldWrapper>{ teamWinProbability?.toFixed(decimalSpot) }%</WinProbabilityBoldWrapper>
            <PercentageWrapper>(<WinProbabilityBoldWrapper className={plusMinus}>{ abs(teamWinProbabilityAdded?.toFixed(decimalSpot))}</WinProbabilityBoldWrapper>)</PercentageWrapper>
        </WinProbabilityWrapper>
    );
};

WinProbability.propTypes = {
    awayTeamName: PropTypes.string,
    homeTeamName: PropTypes.string,
    halfInning: PropTypes.string,
    keymoments: PropTypes.object
};

export default WinProbability;
